/* eslint-disable @typescript-eslint/no-unused-vars */
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useContext, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Link, useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import { Button, Card, Input } from '../../components';
import AuthContext from '../../contexts/AuthContext';
import AuthError from '../../errors/authentication.error';
import { LoginForm, schema } from '../../validations/login.validation';

import useStyles from './styles';
import UnauthorizedLayout from '../../layouts/UnauthorizedLayout';

const PasswordIcon = ({
  className,
  isVisible,
  onClick,
}: {
  isVisible: boolean;
  className: string;
  onClick: () => void;
}): JSX.Element =>
  isVisible ? (
    <VisibilityOff className={className} onClick={onClick} />
  ) : (
    <Visibility className={className} onClick={onClick} />
  );

export const Login = (): JSX.Element => {
  const styles = useStyles();
  const { login } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const history = useNavigate();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<LoginForm>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = async ({ email, password }: LoginForm) => {
    try {
      await login(email, password);
      history('/');
    } catch (err) {
      const error = err instanceof AuthError ? err : new AuthError(err);
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  return (
    <UnauthorizedLayout>
      <form className={styles.form} onSubmit={handleSubmit(onSubmitHandler)}>
        <Card className={styles.loginCard}>
          <span className={styles.title}>Login</span>
          <Input
            label="e-mail"
            type="string"
            autoComplete="email"
            placeholder="digite seu email"
            autoFocus
            helperText={errors.email?.message || ' '}
            validationRegister={register('email')}
            error={Boolean(errors.email)}
          />
          <Input
            label="senha"
            autoComplete="password"
            type={isPasswordVisible ? 'text' : 'password'}
            placeholder="digite sua senha"
            endIcon={
              <PasswordIcon
                className={styles.passwordIcon}
                isVisible={isPasswordVisible}
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
              />
            }
            helperText={errors.password?.message || ' '}
            validationRegister={register('password')}
            error={Boolean(errors.password)}
          />
          <Button type="submit" loading={isSubmitting}>
            Entrar
          </Button>
          <div className={styles.forgotPassword}>
            <Link to="/forgot-password">esqueci minha senha</Link>
          </div>
        </Card>
      </form>
    </UnauthorizedLayout>
  );
};

export default Login;
